import { render, staticRenderFns } from "./WorkBookQuestionsClosedWithSelect.vue?vue&type=template&id=f3b1a056&scoped=true&"
import script from "./WorkBookQuestionsClosedWithSelect.vue?vue&type=script&lang=js&"
export * from "./WorkBookQuestionsClosedWithSelect.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookQuestionsClosedWithSelect.vue?vue&type=style&index=0&id=f3b1a056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b1a056",
  null
  
)

export default component.exports